// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__NHLHM","footer":"Form_footer__3qcb7"};